module.exports = __webpack_public_path__ + "img/mastercard.153dee4b.svg";